// All imports moved to individual component files
// All CommonJS helper functions removed - no longer needed with ES6 modules
import { onSortGoTo } from './utils.js';


// BuyButton - used in product pages and product cards
import './components/buy-button.js';

// CollapsibleManager moved to components/collapsible-manager.js
import './components/collapsible-manager.js';

// ExpandableManager moved to components/expandable-manager.js
import './components/expandable-manager.js';

// Accessibility helper moved to utils.js

// Cart moved to components/cart.js

// MobileNavigation moved to components/mobile-navigation.js

// ModalManager moved to components/modal-manager.js
import './components/modal-manager.js';

// NewsletterPopup moved to components/newsletter-popup.js

// OverflowScroller moved to components/overflow-scroller.js

// HorizontalScrollSlider moved to components/cos-slider.js
import './components/cos-slider.js';

// CosCodeReducer moved to components/cos-code-reducer.js
import './components/cos-code-reducer.js';

// CosTooltip moved to components/tooltip.js
import './components/tooltip.js';

// PopoverManager moved to components/popover-manager.js
import './components/popover-manager.js';

// ProductItemColorSwatch moved to components/product-item-color-swatch.js

// ProductItem moved to components/product-item.js
import './components/product-item.js';

// Slider moved to components/slider.js
import './components/slider.js';

// ProgressBar moved to components/progress-bar.js
import './components/progress-bar.js';

// Form moved to components/form.js
import './components/form.js';

// VariantPicker moved to components/variant-picker.js
// All VariantPicker helper functions moved to components/variant-picker.js


// ProductModel moved to components/product-model.js

// ProductVideo moved to components/product-video.js

// ProductGallery moved to components/product-gallery.js

// PhotoSwipe and Drift imports moved to individual component files

// QuantityPicker moved to components/quantity-picker.js

// Form helper moved to utils.js

// ShippingEstimator moved to components/shipping-estimator.js

// ValuePicker moved to components/value-picker.js

// AccountSection moved to sections/account-section.js

// All section classes moved to sections/ directory

// Tabs component
import './tabs.js';

// BackToTop component
import './components/back-to-top.js';

// Wishlist component
// import './components/wishlist.js';

// CosSideCart component
import './components/cart.js';

// Fix viewport height on mobile browsers
function setViewportHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// Set viewport height on load and resize
window.addEventListener('resize', setViewportHeight);
window.addEventListener('orientationchange', setViewportHeight);
setViewportHeight();

// Smile UI and anchor handling
(function (window, document) {
  'use strict';

  function handleSmile() {
    window.SmileUI.ready().then(() => {
      // possible param: smileUiInstance
      window.SmileUI.openPanel();
    }).catch(e => {
      // An error has occurred will intializing SmileUI      
      Bugsnag.notify(e);
      console.warn(e);
    });
  }

  function handleTarget(targetHash) {
    // console.log('handleTarget', targetHash);
    const target = targetHash || window.location.hash;
    if (!target || target === '') return;
    // console.log('handleTarget', target);
    // window.location.hash = '';

    // smile-home
    if (target === 'smile-home' || target === '#smile-home') {
      if (window.SmileUI) {
        handleSmile();
      } else {
        document.addEventListener('smile-ui-loaded', () => {
          handleSmile();
        });
      }

      return;
    };
  
    const onSortScrollTo = document.querySelector(target.includes('#') ? target : '#' + target);
    if (!onSortScrollTo) return;

    onSortGoTo(onSortScrollTo);
  
    // remove hash from url
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  addEventListener('DOMContentLoaded', () => {
    handleTarget();

    const allRelativeLinks = document.querySelectorAll('[is-anchor]');
    allRelativeLinks.forEach((link) => {
      link.addEventListener('click', (e) => { 
        // Check if the page has the same relative link
        const origin = window.location.origin;
        const href = link.getAttribute('href').replace(origin, '');
        const hrefPath = href.split('#')[0];
        
        if (hrefPath === '' || hrefPath === window.location.pathname) {
          e.preventDefault();

          const target = href.split('#')[1];
          handleTarget(target);
        }
      });
    });

    // data-goto links
    const allGoToLinks = document.querySelectorAll('[data-goto]');
    allGoToLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        
        let target = link.getAttribute('data-goto');
        if (target === 'nextSection') {
          const nextSection = link.closest('.shopify-section').nextElementSibling;
          if (nextSection) {
            if (nextSection.classList.contains('shopify-section')) target = nextSection.id;
          }
        }

        handleTarget(target);
      });
    });
  });

  addEventListener('hashchange', (e) => {
    handleTarget();
  });
})(window, document);
